import React, { createContext, useContext, useState, useEffect } from 'react'
import axios from '../utils/http/axios-local'
import { keysToCamel } from '../utils/case-coverters'
import { useCurrentUser } from './CurrentUserContext'

interface IFeatureFlags {
  imageLibrary: boolean
}

const defaultFlags: IFeatureFlags = {
  imageLibrary: false
}

const FeatureFlagsContext = createContext<IFeatureFlags>(defaultFlags)

export const FeatureFlagsProvider: React.FC = ({ children }) => {
  const [flags, setFlags] = useState<IFeatureFlags>(defaultFlags)
  const { currentUser } = useCurrentUser()

  const isLoggedIn = currentUser?.isLoggedIn()

  useEffect(() => {
    const fetchFlags = async () => {
      if (!isLoggedIn) {
        return
      }

      try {
        const response = await axios.get('/api/feature_flags')
        setFlags(keysToCamel(response.data))
      } catch (error) {
        console.error('Failed to fetch feature flags', error)
      }
    }

    fetchFlags()
  }, [isLoggedIn])

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export const useFeatureFlags = () => useContext(FeatureFlagsContext)
